import axios from "axios";
import {
    DASHBOARD_REQUEST,
    DASHBOARD_SUCCESS,
    DASHBOARD_FAIL,
    DASHBOARD_CLEAR_ERRORS
} from "../Constants/dashboard_const";

export const getData = (params) => async (dispatch) => {
  try {
    dispatch({
      type: DASHBOARD_REQUEST,
    });
    const dashboard = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/dashboard-kpis/`,
      {params}
    );
    dispatch({
      type: DASHBOARD_SUCCESS,
      payload: dashboard,
    });
  } catch (error) {
    dispatch({
      type: DASHBOARD_FAIL,
      payload: error.response,
    });
  }
};

export const dashboardClearErrors = () => async (dispatch) => {
    dispatch({
      type: DASHBOARD_CLEAR_ERRORS,
    });
  };
  